<template>
  <v-navigation-drawer
    v-model="drawerState"
    class="app-drawer text-white"
    :temporary="isMobile"
    :permanent="!isMobile"
    :width="drawerWidthValue"
    :scrim="isMobile"
  >
    <v-img class="mt-4 mx-6 mb-2" height="50" src="@/assets/img/PCSE.png" />
    <div class="app-brand-title">Trackly</div>

    <v-list>
      <v-tooltip
        v-if="['professor', 'coordenador'].includes($store.state.userType)"
        location="right"
        text="Início"
      >
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-home"
            title="Início"
            :to="'/Painel'"
          />
        </template>
      </v-tooltip>

      <v-divider class="my-2" />

      <v-tooltip location="right" text="Assistente">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-chat-question"
            title="Assistente"
            to="/Assistente"
            @click="closeMobileDrawer"
          />
        </template>
      </v-tooltip>

      <v-divider class="my-2" />

      <!-- Pessoal -->
      <v-list-group value="Pessoal">
        <template v-slot:activator="{ props: gProps }">
          <v-tooltip location="right" text="Pessoal">
            <template #activator="{ props: tProps }">
              <v-list-item
                v-bind="{ ...gProps, ...tProps }"
                prepend-icon="mdi-account"
                title="Pessoal"
              />
            </template>
          </v-tooltip>
        </template>
        <v-tooltip
          v-for="([title, value, icon], i) in pessoal"
          :key="i"
          location="right"
          :text="title"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              :title="title"
              :value="value"
              :to="value"
              :prepend-icon="icon"
              @click="closeMobileDrawer"
            />
          </template>
        </v-tooltip>
      </v-list-group>

      <v-divider class="my-2" />

      <v-tooltip
        v-if="['professor', 'aluno'].includes($store.state.userType)"
        location="right"
        text="Materiais"
      >
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-folder-multiple"
            title="Materiais"
            to="/Materiais"
            @click="closeMobileDrawer"
          />
        </template>
      </v-tooltip>

      <v-divider
        v-if="['professor', 'aluno'].includes($store.state.userType)"
        class="my-2"
      />

      <template v-if="['professor', 'coordenador'].includes($store.state.userType)">
        <v-list-group value="TBL">
          <template v-slot:activator="{ props: gProps }">
            <v-tooltip location="right" text="TBL">
              <template #activator="{ props: tProps }">
                <v-list-item
                  v-bind="{ ...gProps, ...tProps }"
                  prepend-icon="mdi-account-group"
                  title="TBL"
                />
              </template>
            </v-tooltip>
          </template>
          <v-tooltip
            v-for="([title, value, icon], i) in tblItems"
            :key="i"
            location="right"
            :text="title"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                :title="title"
                :value="value"
                :to="value"
                :prepend-icon="icon"
                @click="closeMobileDrawer"
              />
            </template>
          </v-tooltip>
        </v-list-group>

        <v-divider class="my-2" />

        <v-list-group value="Avaliação Discursiva">
          <template v-slot:activator="{ props: gProps }">
            <v-tooltip location="right" text="Avaliação Discursiva">
              <template #activator="{ props: tProps }">
                <v-list-item
                  v-bind="{ ...gProps, ...tProps }"
                  prepend-icon="mdi-text-box-edit"
                  title="Avaliação Discursiva"
                />
              </template>
            </v-tooltip>
          </template>
          <v-tooltip
            v-for="([title, value, icon], i) in avaliacaoDiscursivaItems"
            :key="i"
            location="right"
            :text="title"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                :title="title"
                :value="value"
                :to="value"
                :prepend-icon="icon"
                @click="closeMobileDrawer"
              />
            </template>
          </v-tooltip>
        </v-list-group>

        <v-list-group value="OSCE">
          <template v-slot:activator="{ props: gProps }">
            <v-tooltip location="right" text="OSCE">
              <template #activator="{ props: tProps }">
                <v-list-item
                  v-bind="{ ...gProps, ...tProps }"
                  prepend-icon="mdi-clipboard-check"
                  title="OSCE"
                />
              </template>
            </v-tooltip>
          </template>
          <v-tooltip
            v-for="([title, value, icon], i) in osceProf"
            :key="i"
            location="right"
            :text="title"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                :title="title"
                :value="value"
                :to="value"
                :prepend-icon="icon"
                @click="closeMobileDrawer"
              />
            </template>
          </v-tooltip>
        </v-list-group>
      </template>

      <template v-if="['professor', 'coordenador', 'admin', 'administrador_sistema'].includes($store.state.userType)">
        <v-list-group value="Estatística da Turma">
          <template v-slot:activator="{ props }">
            <v-tooltip location="right" text="Estatística da Turma">
              <template #activator="{ props: tProps }">
                <v-list-item
                  v-bind="{ ...props, ...tProps }"
                  prepend-icon="mdi-chart-box"
                  title="Estatística da Turma"
                />
              </template>
            </v-tooltip>
          </template>
          <v-tooltip
            v-for="([title, value, icon], i) in estatisticaTurmaProf"
            :key="i"
            location="right"
            :text="title"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                :title="title"
                :value="value"
                :to="value"
                :prepend-icon="icon"
                @click="closeMobileDrawer"
              />
            </template>
          </v-tooltip>
        </v-list-group>
      </template>

      <template v-if="['administrador_sistema', 'admin'].includes($store.state.userType)">
        <v-tooltip location="right" text="Administração">
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-account-cog"
              title="Administração"
              to="/AdminSistema"
              @click="closeMobileDrawer"
            />
          </template>
        </v-tooltip>
      </template>

      <template v-if="false">
        <v-list-group value="Estatística da Turma">
          <template v-slot:activator="{ props }">
            <v-tooltip location="right" text="Estatística da Turma">
              <template #activator="{ props: tProps }">
                <v-list-item
                  v-bind="{ ...props, ...tProps }"
                  prepend-icon="mdi-chart-box"
                  title="Estatística da Turma"
                />
              </template>
            </v-tooltip>
          </template>
          <v-tooltip
            v-for="([title, value, icon], i) in estatisticaTurmaProf"
            :key="i"
            location="right"
            :text="title"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                :title="title"
                :value="value"
                :to="value"
                :prepend-icon="icon"
                @click="closeMobileDrawer"
              />
            </template>
          </v-tooltip>
        </v-list-group>
      </template>

      <!-- Aluno: TBL -->
      <template v-if="$store.state.userType === 'aluno'">
        <v-tooltip location="right" text="Dashboard Acadêmico">
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-view-dashboard"
              title="Dashboard Acadêmico"
              to="/Aluno/Dashboard"
              @click="closeMobileDrawer"
            />
          </template>
        </v-tooltip>

        <v-list-group value="TBL">
          <template v-slot:activator="{ props: gProps }">
            <v-tooltip location="right" text="TBL">
              <template #activator="{ props: tProps }">
                <v-list-item
                  v-bind="{ ...gProps, ...tProps }"
                  prepend-icon="mdi-chair-school"
                  title="TBL"
                />
              </template>
            </v-tooltip>
          </template>
          <v-tooltip
            v-for="([title, value, icon], i) in salaAula"
            :key="i"
            location="right"
            :text="title"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                :title="title"
                :value="value"
                :to="value"
                :prepend-icon="icon"
                @click="closeMobileDrawer"
              />
            </template>
          </v-tooltip>
        </v-list-group>

        <v-list-group value="Avaliação Discursiva">
          <template v-slot:activator="{ props: gProps }">
            <v-tooltip location="right" text="Avaliação Discursiva">
              <template #activator="{ props: tProps }">
                <v-list-item
                  v-bind="{ ...gProps, ...tProps }"
                  prepend-icon="mdi-text-box-edit"
                  title="Avaliação Discursiva"
                />
              </template>
            </v-tooltip>
          </template>
          <v-tooltip
            v-for="([title, value, icon], i) in avaliacaoDiscursivaAluno"
            :key="i"
            location="right"
            :text="title"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                :title="title"
                :value="value"
                :to="value"
                :prepend-icon="icon"
                @click="closeMobileDrawer"
              />
            </template>
          </v-tooltip>
        </v-list-group>

        <v-list-group value="OSCE">
          <template v-slot:activator="{ props: gProps }">
            <v-tooltip location="right" text="OSCE">
              <template #activator="{ props: tProps }">
                <v-list-item
                  v-bind="{ ...gProps, ...tProps }"
                  prepend-icon="mdi-clipboard-check"
                  title="OSCE"
                />
              </template>
            </v-tooltip>
          </template>
          <v-tooltip
            v-for="([title, value, icon], i) in osceAluno"
            :key="i"
            location="right"
            :text="title"
          >
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                :title="title"
                :value="value"
                :to="value"
                :prepend-icon="icon"
                @click="closeMobileDrawer"
              />
            </template>
          </v-tooltip>
        </v-list-group>
      </template>

      <v-divider class="my-2" />

      <v-tooltip location="right" text="Sair">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-logout"
            title="Sair"
            @click="logout()"
          />
        </template>
      </v-tooltip>
    </v-list>

    <!-- Handle de redimensionamento -->
    <div
      v-if="!isMobile"
      class="drawer-resize-handle"
      @mousedown="startResize"
      :class="{ 'is-resizing': isResizing }"
    />
  </v-navigation-drawer>

  <v-dialog v-model="showLogoutConfirm" max-width="400">
    <v-card prepend-icon="mdi-logout" title="Sair do sistema">
      <v-card-text>
        Tem certeza que deseja sair?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="showLogoutConfirm = false">Cancelar</v-btn>
        <v-btn color="error" variant="flat" @click="confirmLogout">Sair</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script src="@/assets/js/navigation.js" />

<style scoped>
.app-drawer {
  border-right: 1px solid var(--pcse-drawer-border);
  background: var(--pcse-drawer-bg) !important;
  user-select: none;
}

.app-drawer :deep(.v-navigation-drawer__content) {
  padding-top: 8px;
}

.app-drawer :deep(.v-list-item) {
  margin: 4px 10px;
  border-radius: 14px;
  color: rgba(255, 255, 255, 0.9);
}

.app-brand-title {
  margin: 0 24px 12px;
  color: #ffffff;
  font-size: 0.92rem;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
  text-align: center;
}

.app-drawer :deep(.v-list-item:hover),
.app-drawer :deep(.v-list-item--active) {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

.app-drawer :deep(.v-divider) {
  border-color: rgba(255, 255, 255, 0.1);
}

/* â”€â”€ Resize handle â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
.drawer-resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  z-index: 10;
  transition: background 0.15s ease;
}

.drawer-resize-handle:hover,
.drawer-resize-handle.is-resizing {
  background: rgba(255, 255, 255, 0.15);
}
</style>
